import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form, ListGroupItem } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import * as yup from 'yup'

import { IRegistration } from '../../../store/registrations/interfaces'
import { updateRegistration } from '../../../store/registrations/registrations'
import { AddValidatorFunc } from '../../../hooks/validators'
import { RootState } from '../../../store'

const AdditionalData = (props: {
  registration: IRegistration
  editable: boolean
  labelSpecialNotes: string
  setError: (prevState: boolean) => void
  addValidator?: AddValidatorFunc
}) => {
  const {
    registration,
    editable,
    labelSpecialNotes,
    setError,
    addValidator,
  } = props
  const dispatch = useDispatch()

  const { register, trigger, getValues, formState: { errors } } = useForm<{
    specialNotes: string
  }>({
    mode: 'onChange',
    defaultValues: {
      specialNotes: registration.specialNotes,
    },
    resolver: yupResolver(yup.object().shape({
      specialNotes: yup.string(),
    })),
  })
  const lastError = useRef(errors.specialNotes)
  const { loadedViaCode } = useSelector((state: RootState) => state.misc)
  const { originalRegistrationIds } = useSelector(
    (state: RootState) => state.participant.data,
  )

  const isOriginalReg = originalRegistrationIds?.includes(
    registration.event.event_id,
  )

  useEffect(
    () => {
      if (lastError.current === errors.specialNotes) {
        if (editable && addValidator) {
          addValidator(`additionalData-${registration.event.event_id}`, { trigger, formName: 'AdditionalData' })
        }
      } else {
        if (errors.specialNotes) {
          setError(true)
          lastError.current = errors.specialNotes
        } else {
          setError(false)
          lastError.current = errors.specialNotes
        }
      }
    },
    [register, errors.specialNotes])

  return (
    <ListGroupItem className='m-0'>
      {!editable ? (
        <Form.Group>
          <Form.Label>
            Sonstige Hinweise {labelSpecialNotes && `zu "${labelSpecialNotes}"`}
            <br />
            {registration.specialNotes ? (
              <small className='font-weight-bold'>
                {registration.specialNotes}
              </small>
            ) : (
              <small className='text-muted'>Kein Angabe.</small>
            )}
          </Form.Label>
        </Form.Group>
      ) : (
        <>
          <Form.Group>
            <Form.Label>
              Sonstige Hinweise
              <br />
              <small className='font-weight-bold'>{labelSpecialNotes}</small>
            </Form.Label>
            <Form.Control
              {...register('specialNotes', {
                onBlur: () => {
                  dispatch(
                    updateRegistration({
                      eventId: registration.event.event_id,
                      ...getValues(),
                    }),
                  )
                },
              })}
              //id={`specialNotes-${registration.event.event_id}`} TODO: necessary? why?
              as='textarea'
              placeholder='Notiz...'
              disabled={!editable || (loadedViaCode && isOriginalReg)}
              isInvalid={!!errors.specialNotes}
              aria-label='Sonstige Notizen für diese Veranstaltung'
            />
            <Form.Control.Feedback type='invalid'>
              {errors.specialNotes && errors.specialNotes.message}
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}
    </ListGroupItem>
  )
}

export default AdditionalData
